module.exports = __webpack_public_path__ + "img/IMG_2316.546835b9.jpg";